import Config from '@/config';
import {
  ContractListResult,
  DetailResult,
} from '@/types/api/contracts';
import http, { HttpPromise } from './http';

const list = (role: string, params?: ContractListResult): HttpPromise<ContractListResult> => http.get<ContractListResult>(`${Config.apiHost}/${role}/contracts/list/`, { params });
const detail = (role: string, params: { id: number }): HttpPromise<DetailResult> => http.post<DetailResult>(`${Config.apiHost}/${role}/contracts/detail/`, params);

export default {
  supplier: {
    list: list.bind(this, 'supplier'),
    detail: detail.bind(this, 'supplier'),
  },
  contractor: {
    list: list.bind(this, 'contractor'),
    detail: detail.bind(this, 'contractor'),
  },
  customer: {
    list: list.bind(this, 'customer'),
    detail: detail.bind(this, 'customer'),
  },
  administrator: {
    list: list.bind(this, 'customer'),
    detail: detail.bind(this, 'customer'),
  },
};
